import React, { SFC, ReactNode } from 'react';
import { css } from '@emotion/core';
import AppLink from './AppLink';
import ExternalLink from './ExternalLink';
import { CtaThemes, CtaSizes, CtaBase, CtaDisabled } from '../../styles/cta';
import { CtaSizesType, CtaThemesType } from '../../appTypes';

interface CtaProps {
  size?: CtaSizesType;
  disabled?: boolean;
  theme?: CtaThemesType;
  to?: string;
  alternateText?: string;
  type?: string;
}

const Cta: SFC<CtaProps> = ({
  children,
  to,
  size,
  theme,
  disabled,
  alternateText,
  type,
  ...rest
}) => {
  if (type === 'submit') {
    return (
      <button
        data-text={alternateText || children}
        css={css`
          ${CtaBase};
          ${CtaSizes[size]}
          ${CtaThemes[theme]}
          ${disabled && CtaDisabled}
        `}
        type="submit"
        {...rest}
      >
        <span>{children}</span>
      </button>
    );
  }
  const internal = /^\/(?!\/)/.test(to);
  if (internal) {
    return (
      <AppLink
        data-text={alternateText || children}
        css={css`
          ${CtaBase};
          ${CtaSizes[size]}
          ${CtaThemes[theme]}
          ${disabled && CtaDisabled}
        `}
        to={to}
        {...rest}
      >
        <span>{children}</span>
      </AppLink>
    );
  }
  return (
    <ExternalLink
      data-text={alternateText || children}
      css={css`
        ${CtaBase}
        ${CtaSizes[size]}
        ${CtaThemes[theme]}
        ${disabled && CtaDisabled}
      `}
      href={to}
      {...rest}
    >
      <span>{children}</span>
    </ExternalLink>
  );
};

Cta.defaultProps = {
  size: 'M',
  theme: 'primary',
  disabled: false,
};

export default Cta;
